import { useEffect, useState } from 'react';
import './BayIndex.scss';
import Header from '../../common/Header/Header';
import Error from '../../common/Error/Error';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import Hub from '../../api/controllers/Hub/Hub';
import BayList from '../../common/BayList/BayList';
import { useNavigate } from 'react-router-dom';

const BayIndex = () => {
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const [bays, setBays] = useState();
  const [racks, setRacks] = useState();

  const navigate = useNavigate();

  const hubId = JSON.parse(localStorage.getItem('user')).currentHubId;

  const getBays = () => {
    setLoading(true);
    Hub.show(hubId)
      .then(response => {
        setBays(response.bays.filter(bay => bay.bayType != 'racking'));
        const racks = response.bays.filter(bay => bay.bayType == 'racking');
        setRacks(Object.groupBy(racks, rack => rack.bayNumber));
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  useEffect(() => {
    getBays();
  }, []);

  return (
    <div className="bay_index_container">
      <Header title={'Bays'} rightButton={'home'} />
      {error && (
        <Error
          errorMessages={error}
          type={'info'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's occurred:' : ' occurred:'} `
              : ''
          }
        />
      )}
      {loading && <LoadingSpinner />}
      <div className="divider" />
      <BayList
        bays={bays}
        racks={racks}
        handleClick={bay => navigate(`/bays/${bay == 'none' ? 'none' : bay.id}`)}
      />
    </div>
  );
};

export default BayIndex;
